import { i18n } from "@lingui/core";
import type { CarAd } from "@mobility-item-page/types";
import { EvFaqLinks } from "./EvFaqLinks.tsx";

type Props = {
  ad: CarAd;
};

export const EvGuidesCard = ({ ad }: Props) => {
  if (!ad.ev_info_links) {
    return null;
  }

  return (
    <section className="s-bg rounded-8 p-16">
      <EvFaqLinks
        title={i18n.t({
          id: "itemPageLayout.ev.guidesCard.title",
          message: "More guides to buying an electric car",
          comment: "Title for the guides card in the EV info section",
        })}
        links={ad.ev_info_links.more_help}
      />
    </section>
  );
};
